<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebar"><a id="file_010">
<p class="image"><img alt="Image" src="images/f0008-02.jpg"/></p>
<p class="caption">A new Grumman F4F-3 Wildcat cruises the skies over Long Island in late 1942. The Wildcat was a great success, but it was outmatched by contemporary fighters of other nations. <em>Grumman History Center</em></p>
</a></div><a id="file_010">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_010.vue?e4cd5f72